<script lang="ts">export let active = false;
</script>

<svg
	width="16"
	height="16"
	viewBox="0 0 16 16"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	style="opacity: {active ? 1 : 0.7}; transition: opacity 0.3s; margin-top: 2px;"
>
	<g filter="url(#filter0_d_4628_67873)">
		<path
			d="M10.6088 1.78271H5.39141C3.95141 1.78271 2.78271 2.94678 2.78271 4.38228V7.50384V8.02584C2.78271 9.46134 3.95141 10.6254 5.39141 10.6254H6.17402C6.31489 10.6254 6.50271 10.7194 6.59141 10.8342L7.37402 11.873C7.71837 12.3323 8.28185 12.3323 8.62619 11.873L9.4088 10.8342C9.50793 10.7037 9.66445 10.6254 9.82619 10.6254H10.6088C12.0488 10.6254 13.2175 9.46134 13.2175 8.02584V4.38228C13.2175 2.94678 12.0488 1.78271 10.6088 1.78271ZM5.91315 7.00272C5.62098 7.00272 5.39141 6.76782 5.39141 6.48072C5.39141 6.19362 5.62619 5.95872 5.91315 5.95872C6.20011 5.95872 6.43489 6.19362 6.43489 6.48072C6.43489 6.76782 6.20532 7.00272 5.91315 7.00272ZM8.00011 7.00272C7.70793 7.00272 7.47837 6.76782 7.47837 6.48072C7.47837 6.19362 7.71315 5.95872 8.00011 5.95872C8.28706 5.95872 8.52185 6.19362 8.52185 6.48072C8.52185 6.76782 8.29228 7.00272 8.00011 7.00272ZM10.0871 7.00272C9.79489 7.00272 9.56532 6.76782 9.56532 6.48072C9.56532 6.19362 9.80011 5.95872 10.0871 5.95872C10.374 5.95872 10.6088 6.19362 10.6088 6.48072C10.6088 6.76782 10.3792 7.00272 10.0871 7.00272Z"
			fill="url(#paint0_linear_4628_67873)"
		/>
	</g>
	<defs>
		<filter
			id="filter0_d_4628_67873"
			x="0.782715"
			y="0.782715"
			width="14.4348"
			height="14.4346"
			filterUnits="userSpaceOnUse"
			color-interpolation-filters="sRGB"
		>
			<feFlood flood-opacity="0" result="BackgroundImageFix" />
			<feColorMatrix
				in="SourceAlpha"
				type="matrix"
				values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				result="hardAlpha"
			/>
			<feOffset dy="1" />
			<feGaussianBlur stdDeviation="1" />
			<feComposite in2="hardAlpha" operator="out" />
			<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
			<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4628_67873" />
			<feBlend
				mode="normal"
				in="SourceGraphic"
				in2="effect1_dropShadow_4628_67873"
				result="shape"
			/>
		</filter>
		<linearGradient
			id="paint0_linear_4628_67873"
			x1="8.00011"
			y1="1.78271"
			x2="11.5"
			y2="13.0002"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="white" />
			<stop offset="1" stop-color="#999999" />
		</linearGradient>
	</defs>
</svg>
